import { render, staticRenderFns } from "./modificar-avance-button.vue?vue&type=template&id=36c7318b&scoped=true&"
import script from "./modificar-avance-button.vue?vue&type=script&lang=js&"
export * from "./modificar-avance-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7318b",
  null
  
)

export default component.exports